import { computed } from "vue";
import { useMyDepartmentsStore, wireMyDepartments } from "@/shared/stores/myDepartmentsStore";

/**
 * The caller's departments, and what they may do in each, for a picker — see
 * `shared/stores/myDepartmentsStore.ts` for what is read, when, and how it is kept current.
 *
 * Nothing is read by calling this. A dialog calls `ready()` when it opens: the list, and what the
 * caller holds in each department, which `granting` and `can` answer from. Until `ready()` has
 * settled they answer "none", which is the safe answer for a picker that is about to offer a choice.
 */
export function useMyDepartments() {
	const store = useMyDepartmentsStore();
	wireMyDepartments(store);

	return {
		/** Every department the caller is in, the default department's implicit membership included. */
		departments: computed(() => store.departments),
		/** The list has been read. */
		known: computed(() => store.list !== null),
		loading: computed(() => store.loading),
		error: computed(() => store.error),
		/** Reads the list and what is held in each department, unless it was read a moment ago. */
		ready: () => store.loadHeld(),
		/** What the caller holds in each department, by id. */
		held: computed(() => store.held),
		can: store.can,
		/** The departments where the caller holds `entitlement`. */
		granting: store.granting,
	};
}
